module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result20-2e07e2ee1bc167c345c72e0b3ec20a4f.png";